import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-despre-noi',
  templateUrl: './despre-noi.component.html',
  styleUrls: ['./despre-noi.component.scss']
})
export class DespreNoiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
